import * as Yup from 'yup';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useReactHookForm } from '../../../hooks/useReactHookForm';
import { ReactHookForm } from '../../../components/hook-form/react-hook-form.component';
import { DateFormat, FormDateField } from '../../../components/hook-form/form-date.field.component';
import dayjs from 'dayjs';
import { FormCheckbox } from '../../../components/hook-form/form-checkbox.component';
import { FormSelect } from '../../../components/hook-form/form-select.component';
import { useAuthorize } from '../../../hooks/use-authorize';
import { UserPermissionName } from '../../../models/user-permission-name';

const INSPECTION_CODE_RESULT_OPTION = [
  { value: 'Fail', label: 'Fail' },
  { value: 'Pass', label: 'Pass' },
  { value: 'Partial Pass', label: 'Partial Pass' },
  { value: 'Cancelled', label: 'Canceled' },
  { value: 'Waived', label: 'Waived' },
];

const PROCTOR_SAMPLE_COLLECTION_OPTION = [
  { value: 'proctor sample collection completed', label: 'proctor sample collection completed' },
  { value: 'proctor sample collection not completed', label: 'proctor sample collection not completed' },
];

const validationSchema = Yup.object().shape({});

interface ReadyDialogComponent {
  onClosed: () => void;
  handleWorkFlowFormSubmit: (data: any) => void;
  isOpenWorkFlowDialog: {
    isDialogOpen: boolean;
    isDropDown: boolean;
    isProctor: boolean;
  };
}

export const WorkFlowDialogComponenet = ({
  onClosed,
  handleWorkFlowFormSubmit,
  isOpenWorkFlowDialog,
}: ReadyDialogComponent) => {
  const form = useReactHookForm({
    yupSchema: validationSchema,
    defaultValues: {
      reinspectionRequired: false,
      inspectionCodeResult: undefined,
    },
  });

  const handleSubmit = (data: any) => {
    const newData = {
      inspectionCodeResult: data?.inspectionCodeResult,
      isReinspectionRequired: !data?.reinspectionRequired ? undefined : data?.reinspectionRequired,
    };
    handleWorkFlowFormSubmit(newData);
  };

  const watchField = form.watch();

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Dialog
      open={true}
      fullWidth={true}
      maxWidth={'sm'}
    // onClose={onClosed}
    >
      <DialogTitle id="scroll-dialog-title">Work Flow</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClosed}
        sx={{
          position: 'absolute',
          right: 10,
          top: 15,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <ReactHookForm formName="PROJECT_FORM" onSubmit={handleSubmit} formContextProps={form}>
        <DialogContent dividers className="popupDilog">
          <Grid container spacing={2}>
            {!isOpenWorkFlowDialog?.isDropDown && (
              <Grid item lg={12} sm={12} xl={12} xs={12}>
                <FormCheckbox label="Reinspection Required" name="reinspectionRequired" />
              </Grid>
            )}
            {isOpenWorkFlowDialog?.isDropDown && (
              <Grid item lg={12} sm={12} xl={12} xs={12}>
                <FormSelect
                  name="inspectionCodeResult"
                  label=" Inspection Code Result"
                  options={
                    !isOpenWorkFlowDialog?.isProctor ? INSPECTION_CODE_RESULT_OPTION : PROCTOR_SAMPLE_COLLECTION_OPTION
                  }
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
          <DialogActions className="spaceBetween">
            <Button variant="outlined" style={{ width: '130px' }} onClick={onClosed}>
              Cancel
            </Button>
            <Button
              disabled={(isOpenWorkFlowDialog?.isDropDown && !watchField?.inspectionCodeResult) || isReadOnlyPermission}
              type="submit"
              variant="contained"
              style={{ width: '100px' }}
            >
              Save
            </Button>
          </DialogActions>
        </div>
      </ReactHookForm>
    </Dialog>
  );
};
